<template>
	<main class="height-100dvh">
		<header class="mob-back-header gap-2 head-dropdown">
			<img src="../../assets/mobile/assprog/mobileBackArrow.svg" alt="" />
			Personal Information
			<!-- <div class="position-relative">
				<img
					src="../../assets/newdesign/dashboard/newUploadModal/headerDownArrow.svg"
					alt=""
				/>
                
			</div> -->
			<b-dropdown no-caret>
				<template #button-content>
					<img
						src="../../assets/newdesign/dashboard/newUploadModal/headerDownArrow.svg"
						alt=""
					/>
				</template>
				<b-dropdown-item
					href="#"
					v-for="i in loopvar"
					:key="i"
					class="d-flex justify-content-between"
				>
					<span>Personal Details</span>
					<span class="missing">Missing fields</span>
				</b-dropdown-item>
			</b-dropdown>
		</header>
		<div class="mob-back-body">
			<section class="mobjd-applied-top">
				<CustomForm :isMobile="true" />
			</section>
			<section class="mobjd-applied-footer w-100 px-3">
				<div class="mob-cancelBtn w-50 pr-2">
					<b-button class="w-100">Cancel</b-button>
				</div>
				<div class="mob-addBtn position-relative w-50 pl-2">
					<b-button class="w-100 pointer" @click="openModal()">Save</b-button>
					<!-- <div v-if="buttonLoader" class="loader-pos-mob">
					<Loader />
				</div> -->
				</div>
			</section>
		</div>
		<FormModal v-if="openFormModal" :isOpenForm="openFormModal" />
	</main>
</template>

<script>
import CustomForm from "@/views/Dashboard/Forms/CustomForm.vue";
import FormModal from "@/components/BuilderPage/FormModal.vue";
export default {
	name: "Form",
	data() {
		return {
			loopvar: 5,
			openFormModal: false,
		};
	},
	components: {
		CustomForm,
		FormModal,
	},
	methods: {
		openModal() {
			this.openFormModal = true;
		},
	},
};
</script>

<style>
.head-dropdown .btn-secondary {
	background-color: #ffffff;
	border: none;
	border-color: none;
	padding: 0;
}

.head-dropdown .btn-secondary:not(:disabled):not(.disabled):active,
.head-dropdown .btn-secondary:not(:disabled):not(.disabled).active,
.head-dropdown .show > .btn-secondary.dropdown-toggle {
	background-color: #ffffff;
}

.head-dropdown .btn-group > .btn:focus {
	box-shadow: none;
}

.head-dropdown .b-dropdown ul {
	left: -120px;
}
.head-dropdown .dropdown-menu {
	padding: 0;
	border-radius: 5px;
	border: 1px solid #b7d6ee;
	overflow: hidden;
}

.head-dropdown .dropdown-item {
	padding: 10px 10px;
	font-family: "Lato", sans-serif;
	font-size: 13px;
	font-weight: 500;
	color: #3a3c40;
	background-color: #f9f9f9;
}

.missing {
	font-family: "Montserrat", sans-serif;
	font-size: 12px;
	font-weight: 500;
	color: #f28b2b;
	padding: 5px;
	border-radius: 4px;
	background-color: #f3e7d2;
	margin-left: 20px;
}
</style>
